import { ThunkAction } from 'redux-thunk';

import { ComparisonForHighlight, comparisonForHighlight, comparisonForHighlightPut } from '../services/contractApi';
export { ComparisonForHighlight } from '../services/contractApi';

/**
 * ファイル比較用モジュール
 */
export interface ComparisonStateForHighlight {
  comparisonForHighlight: ComparisonForHighlight | null;
  messages: string[];
  status: number;
}

const initialState: ComparisonStateForHighlight = {
  comparisonForHighlight: null,
  messages: [],
  status: 0,
};

const REQUEST_COMPARISON_FOR_HIGHLIGHT = 'REQUEST_COMPARISON_FOR_HIGHLIGHT';
type REQUEST_COMPARISON_FOR_HIGHLIGHT = typeof REQUEST_COMPARISON_FOR_HIGHLIGHT;

const RECEIVE_COMPARISON_FOR_HIGHLIGHT = 'RECEIVE_COMPARISON_FOR_HIGHLIGHT';
type RECEIVE_COMPARISON_FOR_HIGHLIGHT = typeof RECEIVE_COMPARISON_FOR_HIGHLIGHT;

const FAIL_COMPARISON_FOR_HIGHLIGHT = 'FAIL_COMPARISON_FOR_HIGHLIGHT';
type FAIL_COMPARISON_FOR_HIGHLIGHT = typeof FAIL_COMPARISON_FOR_HIGHLIGHT;

const CLEAR_COMPARISON_FOR_HIGHLIGHT = 'CLEAR_COMPARISON_FOR_HIGHLIGHT';
type CLEAR_COMPARISON_FOR_HIGHLIGHT = typeof CLEAR_COMPARISON_FOR_HIGHLIGHT;

const CLEAR_COMPARISON_MESSAGES_FOR_HIGHLIGHT = 'CLEAR_COMPARISON_MESSAGES_FOR_HIGHLIGHT';
type CLEAR_COMPARISON_MESSAGES_FOR_HIGHLIGHT = typeof CLEAR_COMPARISON_MESSAGES_FOR_HIGHLIGHT;

interface RequestComparisonForHighlight {
  type: REQUEST_COMPARISON_FOR_HIGHLIGHT;
}

interface ReceiveComparisonForHighlight {
  type: RECEIVE_COMPARISON_FOR_HIGHLIGHT;
  comparisonForHighlight: ComparisonForHighlight;
}

interface FailComparisonForHighlight {
  type: FAIL_COMPARISON_FOR_HIGHLIGHT;
  messages: string[];
  status: number;
}

interface ClearComparisionForHighlight {
  type: CLEAR_COMPARISON_FOR_HIGHLIGHT;
}

interface ClearComparisionMessagesForHighlight {
  type: CLEAR_COMPARISON_MESSAGES_FOR_HIGHLIGHT;
}

export type ComparisonAction = RequestComparisonForHighlight | ReceiveComparisonForHighlight |
  FailComparisonForHighlight | ClearComparisionForHighlight | ClearComparisionMessagesForHighlight;

type CompareDocumentsForHighlight =
  ThunkAction<void, ComparisonStateForHighlight, undefined, ComparisonAction>;

export function requestComparisonForHighlight(): RequestComparisonForHighlight {
  return {
    type: REQUEST_COMPARISON_FOR_HIGHLIGHT,
  };
}

export function receiveComparisonForHighlight(comparisonForHighlight: ComparisonForHighlight): ReceiveComparisonForHighlight {
  return {
    comparisonForHighlight,
    type: RECEIVE_COMPARISON_FOR_HIGHLIGHT,
  };
}

export function failComparisonForHighlight(messages: string[], status: number): FailComparisonForHighlight {
  return {
    messages,
    status,
    type: FAIL_COMPARISON_FOR_HIGHLIGHT,
  };
}

export function clearComparisionForHighlight(): ClearComparisionForHighlight {
  return {
    type: CLEAR_COMPARISON_FOR_HIGHLIGHT,
  };
}

export function clearComparisionMessagesForHighlight(): ClearComparisionMessagesForHighlight {
  return {
    type: CLEAR_COMPARISON_MESSAGES_FOR_HIGHLIGHT,
  };
}

export function compareDocumentsForHighlight(fileIds: number[], fileTypes: string[]): CompareDocumentsForHighlight {
  return (dispatch) => {
    dispatch(requestComparisonForHighlight());
    // 比較API呼び出し
    comparisonForHighlight(fileIds, fileTypes).then((res) => {
      const { status, result, messages, status_code } = res;
      if (status === 200 && result) {
        dispatch(receiveComparisonForHighlight(result));
      } else {
        dispatch(failComparisonForHighlight(messages, status_code));
      }
    }).catch((err) => {
      dispatch(failComparisonForHighlight([String(err)], 500));
    });
  };
}

export function compareDocumentsForHighlightPut(fromData: string, toData: string): CompareDocumentsForHighlight {
  return (dispatch) => {
    dispatch(requestComparisonForHighlight());
    // 比較API呼び出し
    comparisonForHighlightPut(fromData, toData).then((res) => {
      const { status, result, messages, status_code } = res;
      if (status === 200 && result) {
        dispatch(receiveComparisonForHighlight(result));
      } else {
        dispatch(failComparisonForHighlight(messages, status_code));
      }
    }).catch((err) => {
      dispatch(failComparisonForHighlight([String(err)], 500));
    });
  };
}

export default function reducer(
  state: ComparisonStateForHighlight | undefined,
  action: ComparisonAction,
): ComparisonStateForHighlight {
  if (!state) return initialState;
  switch (action.type) {
    case REQUEST_COMPARISON_FOR_HIGHLIGHT: {
      return state;
    }
    case RECEIVE_COMPARISON_FOR_HIGHLIGHT: {
      const { comparisonForHighlight } = action;
      return { comparisonForHighlight, messages: [], status: 0 };
    }
    case FAIL_COMPARISON_FOR_HIGHLIGHT: {
      const { messages, status } = action;
      return { ...state, messages, status };
    }
    case CLEAR_COMPARISON_FOR_HIGHLIGHT: {
      return initialState;
    }
    case CLEAR_COMPARISON_MESSAGES_FOR_HIGHLIGHT: {
      return { ...state, messages: [] };
    }
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/modules/comparisonHighlight.ts